import { gsap } from 'gsap'
import { deepMerge } from 'js/utils/Utils'
import BaseJsHover from 'js/modules/_base/events/mouse/hover/BaseJsHover'

const defaults = {
  instanceName: 'pager1Hover',
  $names: {
    target: 'a[data-js-hover=pager1]',
    text: '.c-pager_list_txt',
  },
  styleInfo: {
    colorHover: '#010101',
    colorDefault: '#969696',
  },
}

export default class Pager1Hover extends BaseJsHover {
  constructor(options = {}) {
    super()
    deepMerge(this, defaults, options)
  }

  async _enterAnimation($target, num) {
    await new Promise((resolve) => {
      const $text = $target.querySelector(this.$names.text)
      if ($text) {
        gsap.killTweensOf($text, 'color')
        gsap.to($text, {
          color: this.styleInfo.colorHover,
          duration: 0.5,
          ease: 'expo.out',
        })
      }
      gsap.delayedCall(0.2, () => {
        resolve()
      })
    })
  }

  async _leaveAnimation($target, num) {
    await new Promise((resolve) => {
      const $text = $target.querySelector(this.$names.text)
      if ($text) {
        gsap.killTweensOf($text, 'color')
        gsap.to($text, {
          color: this.styleInfo.colorDefault,
          duration: 0.6,
          ease: 'none',
          delay: 0.05,
        })
      }

      resolve()
    })
  }
}